// Temporary constant. Will be added in future
export const pusherErrorTimeout = 60000 as const;
